/**
 * Master-Vorschau-Streifen unter einem Abweichungs-Feld (Variant D).
 *
 * Zeigt den Master-Wert (gekürzt) + „übernehmen"-Button — man sieht sofort,
 * wovon der Channel abgewichen ist, und kann den Master-Wert ins Feld laden.
 */

import { useTranslation } from 'react-i18next'
import { Star, RotateCcw } from 'lucide-react'

interface Props {
  masterValue: string
  onAdopt: () => void
}

export function MasterRibbon({ masterValue, onAdopt }: Props) {
  const { t } = useTranslation()
  const preview = masterValue.length > 140 ? `${masterValue.slice(0, 139)}…` : masterValue

  return (
    <div className="content-master-ribbon flex items-center gap-2 mt-1.5 px-2.5 py-1.5 rounded-md bg-neutral-100 dark:bg-neutral-800/60 text-xs text-neutral-500 dark:text-neutral-400">
      <Star className="h-3 w-3 text-primary-500 shrink-0" aria-hidden="true" />
      <span className="font-mono font-bold uppercase tracking-wide text-neutral-400 shrink-0">{t('productContent.channels.masterLabel')}:</span>
      <span className="flex-1 min-w-0 truncate">{preview}</span>
      <button
        type="button"
        className="content-master-adopt flex items-center gap-1 shrink-0 px-2 py-0.5 rounded border border-neutral-200 dark:border-neutral-700 bg-white dark:bg-neutral-900 text-primary-600 dark:text-primary-400 font-semibold hover:border-primary-500"
        onClick={onAdopt}
      >
        <RotateCcw className="h-3 w-3" />{t('productContent.channels.adopt')}
      </button>
    </div>
  )
}
